import wx from 'weixin-js-sdk' // 微信sdk 版本号是1.6.0
// import global from '../config';
const jsApiList = ['updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone']
// 要用到微信API
function getJSSDK (data, dataForWeixin) {
  /*
     *  data 是调用getJSSDK 所返回来的 微信config 配置
     *  dataForWeixin 是分享所需要的 分享标题 副标题 图片等信息
     */
  console.log('data', data)
  console.log('dataForWeixin', dataForWeixin)
  wx.config({
    debug: false, // 可开启调试模式
    appId: data.appId, // 需要后端接口返回的appid
    timestamp: data.timeStamp, // 需要后端接口返回的timeStamp
    nonceStr: data.nonceStr, // 需要后端接口返回的nonceStr
    signature: data.signature, // 需要后端接口返回的signature
    jsApiList: jsApiList, // 注册的微信jsapi
    success: () => {
      alert('success')
    },
    error: (res) => {
      console.log('error', res)
    }
  })
  const shareData = {
    title: dataForWeixin.title,
    desc: dataForWeixin.desc,
    link: dataForWeixin.linkurl,
    imgUrl: dataForWeixin.imgUrl,
    trigger: function trigger (res) { },
    success: function success (res) { // alert('已分享');
    },
    cancel: function cancel (res) { // alert('已取消');
    },
    fail: function fail (res) { // alert('进来了');
    }
  }
  wx.ready(() => {
    wx.updateAppMessageShareData({ /// /需在用户可能点击分享按钮前就先调用
      title: dataForWeixin.title, // 分享标题
      desc: dataForWeixin.desc, // 分享描述
      link: dataForWeixin.linkurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: dataForWeixin.imgUrl, // 分享图标
      success: function () {
        // 设置成功
      }
    })
    wx.updateTimelineShareData({ // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
      title: dataForWeixin.title, // 分享标题
      link: dataForWeixin.linkurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: dataForWeixin.imgUrl, // 分享图标
      success: function () {
        // 设置成功
      }
    })
    // wx.onMenuShareAppMessage(shareData);
    // 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
    // wx.onMenuShareTimeline(shareData);
    // 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
    // wx.onMenuShareQQ(shareData);
    // 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
    // wx.onMenuShareWeibo(shareData);
  })
  wx.error((res) => { // 注册 wx.config的报错提示
    console.log(JSON.stringify(res) + '微信验证-----错误信息错误信息错误信息-')
  })
}
export default {
  getJSSDK
}
